export default __webpack_public_path__ + "static/Neverwinter-3d27c75f4c177dd8a92f3137ec02bc6a.woff";